module.exports = __webpack_public_path__ + "img/BIRD SHADES RED.0737d62.svg";